<div>
  <form [formGroup]="verticalListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Vertical
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <mat-table matSort [dataSource]="verticalDataSource" (matSortChange)="sortData($event)">
            <ng-container matColumnDef="code">
              <mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Code</span>
                  <input placeholder="Search by Code" type="search" matInput
                    autocomplete="off" formControlName="code" class="mat-input-custom">
                  </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.code}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Name</span>
                    <input placeholder="Search by Name" type="search" matInput
                      autocomplete="off" formControlName="name" class="mat-input-custom">
                    </div>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="alias">
                  <mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Aliases</span>
                      <input placeholder="Search by alias" type="search" matInput
                        autocomplete="off" formControlName="aliasName" class="mat-input-custom">
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.aliasNames}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Status</span>
                        <mat-select formControlName="status" placeholder="Search by Status">
                          @for (status of statusTypes; track status) {
                            <mat-option [value]="status.key">
                              {{status.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.status}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef class="header">
                      <span mat-sort-header>Action</span></mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <span class="__action_edit_icon" (click)="openForm(element.id)">
                          <mat-icon mat-cell>create</mat-icon>
                        </span>
                      </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="verticalColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: verticalColumns;"></mat-row>
                  </mat-table>
                }
              </mat-card-content>
            </mat-card>
          </form>
        </div>